function waitForJQuery(callback) {
    if (typeof jQuery !== 'undefined') {
        callback();
    } else {
        setTimeout(() => waitForJQuery(callback), 100);
    }
}

waitForJQuery(() => {
    console.log('jQuery Loaded.');

    document.dispatchEvent(new Event('jqueryLoaded'));

    (function ($) {
        const methods = {
            async addItem(data, discount = null) {
                try {
                    await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        body: data,
                    });
                    if (discount != null) {
                        await fetch('/cart/update.js', {
                            method: 'POST',
                            headers: {'Content-Type': 'application/json'},
                            body: JSON.stringify({
                                updates: {},
                                discount: discount,
                            }),
                        });
                    }
                } catch (err) {
                    console.error('Erro ao adicionar item ao carrinho:', err);
                    throw err;
                }
            },

            async updateQuantityItem(lineKey, quantity) {
                try {
                    return await $.ajax({
                        type: 'POST',
                        url: '/cart/update.js',
                        data: {
                            updates: {
                                [lineKey]: quantity,
                            },
                        },
                        dataType: 'json',
                    });
                } catch (err) {
                    console.error('Erro ao atualizar a quantidade do item no carrinho:', err);
                    throw err;
                }
            },

            async clearCart() {
                return await $.ajax({
                    type: 'POST',
                    url: 'cart/clear.js',
                    data: {},
                    dataType: 'json',
                });
            },
        };

        window.FormEvents = methods;
    })(jQuery);

    (function ($) {
        const methods = {
            cartDrawer: $('#cart-drawer'),
            cartDrawerOverlay: $('.cart-drawer__overlay'),

            openCartDrawer() {
                this.cartDrawer.removeClass('translate-x-full');
                this.cartDrawerOverlay.removeClass('opacity-0 pointer-events-none');
                document.documentElement.classList.add('overflow-hidden');
            },

            closeCartDrawer() {
                if (!this.cartDrawer.length || !this.cartDrawerOverlay.length) {
                    console.error('Cart drawer or overlay elements are missing.');
                    return;
                }

                this.cartDrawer.addClass('translate-x-full');
                this.cartDrawerOverlay.addClass('opacity-0 pointer-events-none');
                document.documentElement.classList.remove('overflow-hidden');
            },

            async buildCart() {
                try {
                    const cartItemsSection = await $.ajax({
                        url: `${routes.cart_url}?section_id=cart-items-drawer`,
                    });
                    const parser = new DOMParser();
                    const cartItemsContent = parser.parseFromString(cartItemsSection, 'text/html');
                    const $listItems = $(cartItemsContent).find('#cart-drawer__items');
                    this.openCartDrawer();

                    if (!$listItems.length) {
                        console.warn('No cart items found in the response.');
                        return;
                    }

                    $('#cart-drawer__items').empty().html($listItems);
                    const influencer = StoreUtils.getLocalStorageItem(StoreUtils.aliasKey);
                    if (influencer) {
                        StoreUtils.applyDiscountToProducts('influencer', '.card-product', true);
                    } else {
                        StoreUtils.applyDiscountToProducts('normal', '.card-product', true);
                    }
                    document.dispatchEvent(new Event("buildCart"));
                } catch (err) {
                    console.error('Erro ao construir o carrinho:', err);
                }
            },
            async upsell() {
                try {
                    const cartUpsellSection = await $.ajax({
                        url: `${routes.cart_url}?section_id=cart-drawer-upsell`,
                        dataType: 'html'
                    });
                    const parser = new DOMParser();
                    const cartItemsUpsell = parser.parseFromString(cartUpsellSection, 'text/html');
                    const $listItems = $(cartItemsUpsell).find('#cart-drawer__upsell');
                    this.openCartDrawer();

                    if (!$listItems.length) {
                        console.warn('No cart items found in the response.');
                        return;
                    }

                    $('#cart-drawer__upsell').empty().html($listItems);
                    const influencer = StoreUtils.getLocalStorageItem(StoreUtils.aliasKey);
                    if (influencer) {
                        StoreUtils.applyDiscountToProducts('influencer', '.card-product', true);
                    } else {
                        StoreUtils.applyDiscountToProducts('normal', '.card-product', true);
                    }
                } catch (err) {
                    console.error('Erro ao construir o carrinho:', err);
                }
            },
        };

        window.CartDrawerAPI = methods;
    })(jQuery);

    (function ($) {
        const methods = {
            showPrices(card, userIdentifier, containsATC = false) {
                const priceElement = card.querySelector('.card-product__price');
                const comparePriceElement = card.querySelector('.card-product__compare_price');
                const priceInput = card.querySelector('.product_price');
                const discountInput = card.querySelector('.influencer_discount');
                let influencerCodeInput = card.querySelector('.product-influencer-input-code');
                let attributePartnerCode = card.querySelector('input[name="attributes[partnerCode]"]');
                const containerPorcentageDiscountInCard = card.querySelector('.container-porcentage-discount');
                const valuePorcentageDiscountInCard = containerPorcentageDiscountInCard ? containerPorcentageDiscountInCard.querySelector('.porcentage-discount') : null;
                const partnerCodeFromLocalStorage = StoreUtils.getLocalStorageItem(StoreUtils.aliasKey);

                if (!influencerCodeInput && !attributePartnerCode) {
                    const buyTogetherElement = card.closest(".buy-together");
                    influencerCodeInput = buyTogetherElement ? buyTogetherElement.querySelectorAll('.product-influencer-input-code') : null;
                    attributePartnerCode = buyTogetherElement ? buyTogetherElement.querySelector('input[name="attributes[partnerCode]"]') : null;
                };

                if (!priceElement || !priceInput || !discountInput) {
                    console.warn('Missing elements in card:');
                    return;
                }

                if (containsATC && !influencerCodeInput) {
                    console.log("Missing Influencer Input in Card");
                }
                else if (containsATC && influencerCodeInput) {
                    // Apply attributes cart/product
                    if (influencerCodeInput.length > 1) {
                        influencerCodeInput.forEach((element, index) => {
                            if (index == discountInput.dataset.index) {
                                if (!element.value) {
                                    element.value = userIdentifier === 'influencer' ? partnerCodeFromLocalStorage : '';
                                }
                            }
                        });
                        attributePartnerCode.value = userIdentifier === 'influencer' ? `${partnerCodeFromLocalStorage}` : '';
                    }
                    else {
                        influencerCodeInput.value = userIdentifier === 'influencer' ? partnerCodeFromLocalStorage : '';
                        attributePartnerCode.value = userIdentifier === 'influencer' ? `${partnerCodeFromLocalStorage}` : '';
                    };
                };

                const originalPrice = parseFloat(priceInput.value) / 100 || 0;
                const discountValue = parseFloat(discountInput.value);


                if (userIdentifier === 'influencer' && discountValue > 0) {
                    const discountedPrice = StoreUtils.calculateDiscountedPrice(originalPrice, discountValue);
                    const discountPercentage = StoreUtils.calculateDiscountedPriceInPercentage(discountValue, originalPrice);

                    if (discountedPrice) {
                        priceElement.textContent = StoreUtils.formatCurrency(discountedPrice);

                        if (valuePorcentageDiscountInCard) {
                            if (discountPercentage < 4) {
                                valuePorcentageDiscountInCard.textContent = `${StoreUtils.formatCurrency(discountValue)}`;
                            } else {
                                valuePorcentageDiscountInCard.textContent = discountPercentage > 100 ? '100%' : `${discountPercentage}%`;
                            }
                        }

                        priceElement.style.opacity = 1;
                        if (containerPorcentageDiscountInCard) {
                            containerPorcentageDiscountInCard.style.opacity = 1;
                        }
                        if (comparePriceElement) {
                            comparePriceElement.style.opacity = 1;
                        }
                        if (comparePriceElement) {
                            comparePriceElement.style.opacity = 1;
                        }
                    }
                } else {
                    priceElement.textContent = StoreUtils.formatCurrency(originalPrice);
                    priceElement.style.opacity = 1;
                    if (comparePriceElement) {
                        comparePriceElement.remove();
                    }
                }
            },
        };

        window.CardProducts = methods;
    })(jQuery);

    function triggerEventQuantityProductForm() {
        const quantityInput = document.querySelector('#product-form #product-form-quantity');

        if (quantityInput) {
            quantityInput.value = 1;
            const event = new Event('input', {
                bubbles: true,
                cancelable: true,
            }); 
            quantityInput.dispatchEvent(event);
        }
    }

    $(document).on('submit', 'form[action*="/cart/add"]', async function (e) {
        e.preventDefault();
        const $form = $(this);

        try {
            if ($form.serialize().includes('bogo')) {
                await FormEvents.addItem($form.serialize(), 'getafree');
            } else {
                await FormEvents.addItem($form.serialize());
                const $swatchLabels = jQuery('.variant-swatch');

                if ($swatchLabels.length) {
                    const $input = $swatchLabels.find('input[name="variant"]').first();
                    if ($input.length) {
                        $input.trigger('click');
                    }
                }
            }
            await CartDrawerAPI.buildCart();
            await CartDrawerAPI.upsell();
            if (window.location.pathname.includes('/products/')) {
                $form.find('#product-form-quantity').val(1);
                triggerEventQuantityProductForm();
            };
        } catch (err) {
            console.error('Erro ao adicionar item ao carrinho:', err);
        }
    });

    $(document).on('click', '#header-cart-icon', async function () {
        await CartDrawerAPI.buildCart();
    });
    $(document).on('click', '.cart-drawer__close, .cart-drawer__overlay', async function () {
        await CartDrawerAPI.closeCartDrawer();
    });

    if(window.location.href.includes('openCart')) {
        CartDrawerAPI.openCartDrawer();
    };
});